
import React from 'react';
import { SifatHuruf } from '../types';

interface SifatViewProps {
  sifat: SifatHuruf[];
}

const SifatView: React.FC<SifatViewProps> = ({ sifat }) => {
  return (
    <div className="p-5 md:p-8 animate-fadeIn">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-black text-dark mb-2 uppercase tracking-tight">SIFAT HURUF</h2>
        <p className="text-body text-xs md:text-sm font-medium">Karakteristik Bunyi Huruf Hijaiyah</p>
        <div className="h-1 w-16 bg-primary mx-auto mt-4 rounded-full"></div>
      </div>

      {/* Mobile Layout (Cards) */}
      <div className="grid grid-cols-1 gap-4 md:hidden">
        {sifat.map((item) => (
          <div key={item.no} className="bg-white border border-stroke rounded-2xl p-5 shadow-sm hover:shadow-md transition-all">
            <div className="flex justify-between items-center mb-4 border-b border-stroke pb-3">
              <span className="bg-primary/10 text-primary w-8 h-8 rounded-lg flex items-center justify-center font-black text-xs">{item.no}</span>
              <h3 className="font-black text-dark text-lg uppercase tracking-tight">{item.sifat}</h3>
            </div>
            <p className="text-body text-sm mb-4 leading-relaxed font-medium">{item.keterangan}</p>
            <div className="bg-bg p-4 rounded-xl flex flex-wrap gap-2 justify-center border border-stroke">
              {item.huruf.map((h, i) => (
                <span key={i} className="arabic-font text-3xl text-dark drop-shadow-sm">{h}</span>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Desktop Layout (Table) */}
      <div className="hidden md:block overflow-hidden rounded-2xl border border-stroke shadow-lg">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-primary text-white">
              <th className="px-6 py-5 text-[10px] font-black uppercase tracking-widest text-center">No</th>
              <th className="px-6 py-5 text-[10px] font-black uppercase tracking-widest">Sifat Karakter</th>
              <th className="px-6 py-5 text-[10px] font-black uppercase tracking-widest">Keterangan Detail</th>
              <th className="px-6 py-5 text-[10px] font-black uppercase tracking-widest text-right">Huruf Aktif</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-stroke bg-white">
            {sifat.map((item) => (
              <tr key={item.no} className="hover:bg-bg transition-colors group">
                <td className="px-6 py-6 text-center text-sm font-black text-primary">{item.no}</td>
                <td className="px-6 py-6">
                  <span className="font-black text-dark tracking-tight text-lg uppercase group-hover:text-primary transition-colors">{item.sifat}</span>
                </td>
                <td className="px-6 py-6 text-sm text-body font-medium leading-relaxed max-w-xs">{item.keterangan}</td>
                <td className="px-6 py-6 text-right">
                  <div className="flex flex-wrap justify-end gap-3 max-w-[240px] ml-auto">
                    {item.huruf.map((h, i) => (
                      <span key={i} className="arabic-font text-3xl text-dark group-hover:scale-125 transition-transform">{h}</span>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {sifat.length === 0 && (
        <div className="text-center py-20 bg-bg rounded-3xl border-2 border-dashed border-stroke">
           <p className="text-body font-black text-xs uppercase tracking-[0.2em]">Data Belum Tersedia di Sheet</p>
        </div>
      )}
    </div>
  );
};

export default SifatView;
